export const HEADER = {
  MOBILE_HEIGHT: 64,
  FULL_MOBILE_HEIGHT: 112,
  FULL_DESKTOP_HEIGHT: 48,
};

export const NAVBAR = {
  DASHBOARD_WIDTH: 280,
  DASHBOARD_COLLAPSE_WIDTH: 70,
  MOBILE_BREAKPOINT: 'sm' as const,
  //
  DASHBOARD_ITEM_ROOT_HEIGHT: 48,
  DASHBOARD_ITEM_SUB_HEIGHT: 40,
};

export const ICON = {
  NAVBAR_ITEM: 22,
};
